import { render, staticRenderFns } from "./tab-creative.vue?vue&type=template&id=22d9762a&scoped=true"
import script from "./tab-creative.vue?vue&type=script&lang=js"
export * from "./tab-creative.vue?vue&type=script&lang=js"
import style0 from "./tab-creative.vue?vue&type=style&index=0&id=22d9762a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9762a",
  null
  
)

export default component.exports